<template>
  <div class="c-news-create">
    <div>
      <n-card class="news-card">
        <n-loader :loading="$var('load')" />
        <div class="card-top">
          <n-button flat @click="closeModal">X</n-button>
        </div>
        <div>
          <div>
            <n-items>
              <div class="row">
                <n-input title="ФИО" v-bind="$form.input('fullName')"></n-input>
                <n-input title="ИИН" v-bind="$form.input('iin')"></n-input>
                <n-input title="Телефон" v-bind="$form.input('phone')"></n-input>
              </div>
              <div class="row">
                <n-input title="Табельный номер" v-bind="$form.input('personnelNumber')"></n-input>
                <n-select title="Филиал" :data="branches" item-value="id" :disabled="!isTop" v-bind="$form.input('branch', 'select')" />
                <n-select title="Допуски" :data="possibilities" v-bind="$form.input('possibles', 'select')" />
              </div>
              <div class="row">
                <n-input title="Пароль" v-bind="$form.input('password')"></n-input>
              </div>
            </n-items>
          </div>
          <div class="button-save">
            <n-button color="primary" @click="save">Сохранить</n-button>
          </div>
        </div>
      </n-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CNewsCreate',
  props: {
    branches: {
      required: true,
    },
  },
  data() {
    return {
      types: [
        { value: 'live', title: 'McLive', },
        { value: 'corporate', title: 'Корпоративные новости', },
        { value: 'interesting', title: 'Интересное', },
      ],
      file: null,
      addFile: null,
      readyFile: null,
      readyAddFile: null,
      possibilities: [ 'U', 'C', 'K', 'DLK', 'DT', 'DTN', 'DLV', 'MR', 'SUP', 'LL', 'TR', 'NT1', 'NT2', 'REG', 'GEL', 'MNGR', 'TS', ],
    }
  },
  computed: {
    isTop() {
      let isTop = false
      $n.filter($app.auth.user().accesses, (e) => {
        if ([ 'superAdmin', ].includes(e.title)) {
          isTop = true
        }
      })
      return isTop
    },
  },
  watch: {
    file() {
      this.loadFile(this.file, 'readyFile')
    },
    addFile() {
      this.loadFile(this.addFile, 'readyAddFile')
    },
  },
  created() {
    this.$form.init({
      branch: {},
      fullName: '',
      iin: '',
      phone: '',
      possibles: [],
      personnelNumber: '',
      password: '',
    })
    this.$form.rules({
      branch: ['required'],
      fullName: [ 'required', ],
      iin: [ 'required', ],
      phone: [ 'required', ],
      possibles: [ 'required', ],
      personnelNumber: [ 'required', ],
      password: [ 'required', ],
    })

    if (!this.isTop) {
      this.$form.set('branch', $n.filter(this.branches, (e) => {
        if (e.id === $app.auth.user().branchId) {
          return e
        }
      })[0])
    }
  },
  methods: {
    closeModal() {
      this.$emit('update:show', false)
    },
    loadFile(file, field) {
      $api.files.create({ file: file, }).then((response) => {
        this[field] = response.data.content
      }).finally(() => {
        this.$var('load', false)
      })
    },
    save() {
      if (this.$form.check()) {
        this.$var('load', true)

        const data = {
          ...this.$form.get(),
          branchId: this.$form.get('branch.id'),
        }

        $api.users.createStaj(data).then(() => {
          this.closeModal()
          this.$emit('done')
        }).finally(() => {
          this.$var('load', false)
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.c-news-create {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, .2);

  .row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .n-input {
      margin-right: 10px;
      &:last-child {
        margin-right: 0;
      }
    }
    .n-select {
      margin-right: 10px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .news-card {
    min-width: 700px;
    min-height: 300px;
    position: relative;
  }

  .button-save {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: right;
  }
  .card-top {
    display: flex;
    align-items: center;
    justify-content: right;
    margin-bottom: 20px;
  }
}
</style>
